import _objectSpread from "@babel/runtime/helpers/objectSpread2";

/* eslint-disable camelcase */
// the inputs are in camel case because for widgets on wp, fields or in camel case,
// snake case doesn't work as widget service turns the key into all lower case
import Input from '@nerdwallet/home-app-lib/input';

var requiredInput = function requiredInput(def) {
  return new Input(_objectSpread(_objectSpread({}, def), {}, {
    required: true
  }));
}; // const optionalInput = def => new Input({
//   ...def,
//   required: false,
// });


export var product_id = requiredInput({
  name: 'product_id',
  type: 'string'
});